class Infobar {

  constructor(el) {
    this.el = el;
    this.closeButton  = el.querySelector('button');
    this.storageKey = 'schlosspraxis_infobar_closed';

    if (!this.hasClosed()) {
      this.el.hidden = false;
    } else {
      this.close();
    }

    this.closeButton.addEventListener('click', (e) => {
      e.preventDefault();
      this.setClosed();
      this.close();
    });
  }

  close() {
    this.el.remove();
  }

  hasClosed() {
    return sessionStorage.getItem(this.storageKey) !== null;
  }

  setClosed() {
    sessionStorage.setItem(this.storageKey, '1');
  }
}

const el = document.querySelector('.js-infobar');

if (el !== null) {
  new Infobar(el);
}
